// extracted by mini-css-extract-plugin
export default {"root":"paragraph_root__0BBCg","promo":"paragraph_promo__taXfy","isHome":"paragraph_isHome__7tTjV","noMargin":"paragraph_noMargin__RsBas"};